exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1PK1rQKpDsC63sW7z9p93U{padding:1.42857rem}@media only screen and (min-width:640px){._1PK1rQKpDsC63sW7z9p93U{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MidtermAndFinalExamHFv4_content": "_1PK1rQKpDsC63sW7z9p93U"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/MidtermAndFinalExamHFv4/style.postcss
// module id = 1912
// module chunks = 0